import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getCheckpointByIDService = async (patrol_id) => {
  try {
    const { data, error } = await supabase
      .from("patrol")
      .select()
      .eq("id", patrol_id);
    
    if (error) {
      console.error("Error fetching checkpoint by ID:", error);
      return null;
    }
    
    return data[0];
  } catch (error) {
    console.error("Error in getCheckpointByIDService:", error);
    return null;
  }
};

export const getCheckpointService = async (site_uuid) => {
  try {
    const { data, error } = await supabase
      .from("site_patrol_checkpoint")
      .select()
      .eq("site_uuid", site_uuid)
      .order("id");
    
    if (error) {
      console.error("Error fetching checkpoint:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getCheckpointService:", error);
    return null;
  }
};

export const getCheckpointReportBySiteService = async (site_uuid, startDate = null, endDate = null) => {
  try {
    let query = supabase
      .from("site_patrol_report")
      .select()
      .eq("site_uuid", site_uuid);
    
    if (startDate && endDate) {
      query = query
        .gte("created_at", startDate)
        .lte("created_at", endDate + "T23:59:59");
    }
    
    const { data, error } = await query.order("id", { ascending: false });
    
    if (error) {
      console.error("Error fetching checkpoint report:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getCheckpointReportBySiteService:", error);
    return null;
  }
};

export const setCheckpointService = async (payload) => {
  try {
    const { data, error } = await supabase
      .from("site_patrol_checkpoint")
      .insert(payload);
    
    if (error) {
      console.error("Error setting checkpoint:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in setCheckpointService:", error);
    return null;
  }
};

export const updateCheckpointService = async (payload) => {
  try {
    const { data, error } = await supabase
      .from("site_patrol_checkpoint")
      .update(payload)
      .eq("checkpoint_uuid", payload.checkpoint_uuid);
    
    if (error) {
      console.error("Error updating checkpoint:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in updateCheckpointService:", error);
    return null;
  }
};

export const deleteCheckpointService = async (id) => {
  try {
    const { data, error } = await supabase
      .from("site_patrol_checkpoint")
      .delete()
      .eq("id", id);
    
    if (error) {
      console.error("Error deleting checkpoint:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in deleteCheckpointService:", error);
    return null;
  }
};

export const getAllSitesCheckpointReportService = async (account_uuid) => {
  // ดึง site_uuid ทั้งหมดที่อยู่ภายใต้ account
  const { data: siteData } = await supabase
    .from("account_site")
    .select("site_uuid, site_name")
    .eq("account_uuid", account_uuid);

  if (!siteData?.length) return [];

  // ดึงข้อมูลรายงานการตรวจตราของทุก site พร้อมกัน
  const reportPromises = siteData.map(site => getCheckpointReportBySiteService(site.site_uuid));
  const reportResults = await Promise.all(reportPromises);

  // รวมข้อมูลรายงานทั้งหมดเข้าด้วยกันและเพิ่ม site_name
  const reportsWithSiteName = reportResults.flat().map(report => {
    const site = siteData.find(site => site.site_uuid === report.site_uuid);
    return {
      ...report,
      site_name: site?.site_name || ''
    };
  });

  return reportsWithSiteName.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
};
